import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../../../components/common/Footer";
import Tabs from "../../../components/common/Tabs";

const tabs = [
  {
    link: "/generalsettings/manage-company-settings/company-settings",
    title: "Company Settings",
  },
  {
    link: "/generalsettings/manage-company-settings/company-settings/logo-settings",
    title: "Logo Settings",
  },
  {
    link: "/generalsettings/manage-company-settings/company-settings/portfolio",
    title: "Portfolio",
  },
];

function ManageCompanySettings() {
  return (
    <div className="page-container">
      <div className="main-container">
        <Tabs tabs={tabs} />
        <Outlet />
        {/* Footer  */}
        <Footer />
      </div>
    </div>
  );
}

export default ManageCompanySettings;
